export default __webpack_public_path__ + "static/O0279-65f529bf00f3d6ace9b59fc5d7974f03.png";